import { keepPreviousData, useSuspenseQuery } from "@tanstack/react-query";
import useIdentity from "@/features/ui/hooks/use-identity";
import { settlementManagementApi } from "@/features/my-order/features/settlement-management/api";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import {
  GetUnoFeeListRequest,
  GetUnoFeeListResponse,
} from "@/features/my-order/features/settlement-management/types";
import { toCamelKeyObject } from "@/utils/case";

const useGetUnoFeeList = (params: GetUnoFeeListRequest) => {
  const identity = useIdentity();
  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];

  const { data } = useSuspenseQuery({
    queryKey: ["settlement", "uno-fee-list", companyId, companyType, params],
    queryFn:
      companyId && companyType
        ? () =>
            settlementManagementApi.getUnoFeeList(
              companyType,
              companyId,
              params
            )
        : undefined,
    select: (data) => toCamelKeyObject(data) as GetUnoFeeListResponse,
  });

  return { data };
};

export default useGetUnoFeeList;
